export const dashboardMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Panou de control',
		path: '/',
		icon: 'fa-solid fa-qrcode',
		subMenu: null,
	},
	youtube: {
		id: 'liveMatchesYoutube',
		text: 'Meciurile mele',
		path: '/youtube-live',
		icon: 'fa-solid fa-photo-film',
	},
	review: {
		id: 'reviews',
		text: 'Recenziile mele',
		path: '/reviews',
		icon: 'fa-solid fa-star-sharp',
	},
};

export const collectorMenu = {
	fisaIncasari: {
		id: 'fisaIncasari',
		text: 'Fisa incasari',
		path: '/collector/fisa-incasari',
		icon: 'fa-solid fa-file-invoice-dollar',
	},
};

export const documentsPlayer = {
	accountDocuments: {
		id: 'accountDocumentsPlayer',
		text: 'Documentele tale',
		path: '/management-account/documents-sign',
		icon: 'fa-regular fa-folder-open',
	},
	transferMarkets: {
		id: 'transferMarketsPlayer',
		text: 'Transfer market',
		path: '/transfer-market',
		icon: 'fa-solid fa-user-plus',
	},
};

export const shopManagementUser = {
	shopManagement: {
		id: 'shop',
		text: 'Produse Marketplace',
		icon: 'Dashboard',
	},
	shop: {
		id: 'user-shop',
		text: 'Shop',
		path: '/user-marketplace/shop',
		icon: 'fa-solid fa-shop',
	},
	order: {
		id: 'user-order',
		text: 'Comenziile tale',
		path: '/user-marketplace/orders',
		icon: 'fa-solid fa-cart-shopping',
	},
};

export const userTeam = {
	team: {
		id: 'sustain',
		text: 'Echipe',
		icon: 'Dashboard',
	},
	// usersTeams: {
	//     id: 'users-teams',
	//     text: 'Echipele tale',
	//     path: '/my-teams/all',
	//     icon: 'fa-solid fa-people-group'
	// },
	sustain: {
		id: 'user-sustain-team',
		text: 'Sustine Echipa',
		path: '/my-teams/sustain',
		icon: 'fa-solid fa-beer-mug',
	},
};

export const appManagement = {
	management: {
		id: 'management',
		text: 'Administrare aplicatie',
		icon: 'Dashboard',
	},
	managementCompetitions: {
		id: 'managementCompetitions',
		text: 'Organizare',
		path: '/management-competitions',
		icon: 'fa-solid fa-sitemap',
		subMenu: {
			users: {
				id: 'user',
				text: 'Utilizatori',
				path: '/management/users',
				icon: 'fa-solid fa-users-gear',
			},
			footballTeams: {
				id: 'footballTeams',
				text: 'Echipe',
				path: '/management/football-teams',
				icon: 'fa-brands fa-steam-symbol',
			},
			transfers: {
				id: 'transfers',
				text: 'Transferuri',
				path: '/management/transfers',
				icon: 'fa-solid fa-repeat',
			},
			editionJournal: {
				id: 'editionJournal',
				text: 'Jurnal editii',
				path: '/management/edition-journal',
				icon: 'fa-solid fa-pen-to-square',
			},
			competitions: {
				id: 'competitions',
				text: 'Competitii',
				path: '/management/competitions',
				icon: 'fa-brands fa-playstation',
			},
			disciplinary: {
				id: 'disciplinary',
				text: 'Disciplinar',
				path: '/management/disciplinary',
				icon: 'fa-solid fa-gavel',
			},
			cupManagement: {
				id: 'cupManagement',
				text: 'Cupe/Baraje',
				path: '/management/cup',
				icon: 'fa-solid fa-trophy',
			},
			financial: {
				id: 'financial',
				text: 'Financiar',
				path: '/management/financial',
				icon: 'fa-solid fa-coins',
			},
			docs: {
				id: 'docs',
				text: 'Documente',
				path: '/management/docs',
				icon: 'fa-regular fa-folder-open',
			},
			documentation: {
				id: 'documentation',
				text: 'Documentatie',
				path: '/management/documentation',
				icon: 'fa-regular fa-book',
			},
		},
	},
	marketplace: {
		id: 'marketplace',
		text: 'Marketplace',
		path: '/management/marketplace',
		icon: 'fa-solid fa-cart-shopping-fast',
		subMenu: {
			products: {
				id: 'products',
				text: 'Produse',
				path: '/management/marketplace/products',
				icon: 'fa-regular fa-basket-shopping-plus',
			},
			orders: {
				id: 'orders',
				text: 'Comenzi',
				path: '/management/marketplace/orders',
				icon: 'fa-solid fa-cart-circle-check',
			},
		},
	},
	generalSettings: {
		id: 'generalSettings',
		text: 'Setari generale',
		path: '/management/general-settings',
		icon: 'fa-solid fa-gears',
	},
	reviewsAdministration: {
		id: 'reviewsAdministration',
		text: 'Recenzii',
		path: '/management/reviews-administration',
		icon: 'fa-regular fa-star-sharp',
	},
};

// CRM Inscrieri: shown only to users with CRM access; sub-items are filtered by CRM role in DefaultAside.
export const crmModuleMenu = {
	crm: {
		id: 'crm',
		text: 'CRM Inscrieri',
		path: '/management/crm',
		icon: 'fa-solid fa-bullhorn',
		subMenu: {
			leads: {
				id: 'crmLeads',
				text: 'Leaduri',
				path: '/management/crm/leads',
				icon: 'fa-solid fa-address-book',
			},
			signedTeams: {
				id: 'crmSignedTeams',
				text: 'Echipe inscrise',
				path: '/management/crm/signed-teams',
				icon: 'fa-solid fa-file-signature',
			},
			reports: {
				id: 'crmReports',
				text: 'Rapoarte',
				path: '/management/crm/reports',
				icon: 'fa-solid fa-chart-column',
			},
			editions: {
				id: 'crmEditions',
				text: 'Editii CRM',
				path: '/management/crm/editions',
				icon: 'fa-solid fa-calendar-days',
			},
		},
	},
};

export const matchManagements = {
	matchEvents: {
		id: 'matchEvents',
		text: 'Meciuri Live',
		path: '/match-management/events',
		icon: 'fa-solid fa-headset',
	},
};

export const matchStatisticsManage = {
	matchStatistics: {
		id: 'matchStatistics',
		text: 'Statistici meciuri',
		path: '/management/match-statistics',
		icon: 'fa-solid fa-chart-line',
	},
};

export const administrationAccount = {
	managementAccount: {
		id: 'managementAccount',
		text: 'Administrare cont',
		icon: 'fa-solid fa-chalkboard-user',
	},
	account: {
		id: 'account',
		text: 'Contul tau',
		path: '/management-account/account',
		icon: 'fa-solid fa-chalkboard-user',
	},

	accountDocuments: {
		id: 'accountDocuments',
		text: 'Documentele tale',
		path: '/management-account/documents-sign',
		icon: 'fa-regular fa-folder-open',
	},

	teams: {
		id: 'teams',
		text: 'Echipele tale',
		path: '/management-account/teams',
		icon: 'fa-solid fa-gear',
	},

	transfers: {
		id: 'transfers',
		text: 'Transferuri',
		path: '/management-account/transfers',
		icon: 'fa-solid fa-repeat',
	},

	transferMarket: {
		id: 'transferMarketManager',
		text: 'Transfer market',
		path: '/transfer-market',
		icon: 'fa-solid fa-user-plus',
	},

	players: {
		id: 'addPlayers',
		text: 'Adauga jucatori',
		path: '/management-account/add-players',
		icon: 'fa-solid fa-user-plus',
	},

	teamLot: {
		id: 'teamLot',
		text: 'Lot echipe',
		path: '/management-account/team-lot',
		icon: 'fa-brands fa-steam-symbol',
	},

	manageDisciplinary: {
		id: 'manageDisciplinary',
		text: 'Disciplinar',
		path: '/management-account/management-cards-suspends',
		icon: 'fa-solid fa-wand-magic-sparkles',
	},

	financial: {
		id: 'financial',
		text: 'Financiar',
		path: '/management-account/financial',
		icon: 'fa-solid fa-coins',
	},

	company: {
		id: 'companies',
		text: 'Date facturare',
		path: '/management-account/companies',
		icon: 'fa-solid fa-buildings',
	},
};

export const demoPages = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},
	resetPassword: {
		id: 'resetPassword',
		text: 'Reset password',
		path: 'auth-pages/reset-password',
		icon: 'Login',
	},
	verifyAccount: {
		id: 'verifyAccount',
		text: 'Verify Account',
		path: 'auth-pages/verify-account',
		icon: 'Login',
	},
	register: {
		id: 'register',
		text: 'Register',
		path: 'auth-pages/register',
		icon: 'PersonAdd',
	},

	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const administrationSite = {
	layoutTypes: {
		id: 'administrationSite',
		text: 'Administrare Site',
	},
	media: {
		id: 'news',
		text: 'Media',
		path: 'page-layouts',
		icon: 'fa-solid fa-photo-film',
		subMenu: {
			news: {
				id: 'news',
				text: 'Stiri',
				path: 'media/news',
				icon: 'fa-regular fa-newspaper',
			},
			chronicles: {
				id: 'chronicles',
				text: 'Cronici',
				path: 'media/chronicles',
				icon: 'fa-regular fa-feather',
			},
			interviews: {
				id: 'interviews',
				text: 'Interviuri',
				path: 'media/interviews',
				icon: 'fa-regular fa-newspaper',
			},
			matches: {
				id: 'matchEvents',
				text: 'Meciuri',
				path: '/media/matches',
				icon: 'fa-solid fa-photo-film',
			},
			broadcastChannels: {
				id: 'broadcastMenu',
				text: 'Broadcast',
				path: '/media/broadcast',
				icon: 'fa-solid fa-video',
			},
			partners: {
				id: 'partners',
				text: 'Parteneri',
				path: '/media/partners',
				icon: 'fa-regular fa-handshake',
			},
			awards: {
				id: 'awards',
				text: 'Awards',
				path: '/media/awards',
				icon: 'fa-regular fa-award',
			},
			legends: {
				id: 'legends',
				text: 'Legende',
				path: '/media/legends',
				icon: 'fa-solid fa-person-arrow-up-from-line',
			},
			winnerTeams: {
				id: 'winnerTeams',
				text: 'Winner Teams',
				path: '/media/winner-teams',
				icon: 'fa-solid fa-trophy',
			},
		},
	},
	questions: {
		id: 'questions',
		text: 'Q&A',
		path: '/questions',
		icon: 'fa-regular fa-message-question',
	},
	menus: {
		id: 'menusLandingPage',
		text: 'Setari meniu',
		path: '/landing-page-menus',
		icon: 'fa-solid fa-gears',
	},
};
